// server/pwa/src/lib/platform/index.ts
//
// Single-slot adapter registry. `main.ts` calls `setPlatform(...)`
// exactly once at boot before any other module imports `platform()`.
// A second `setPlatform` call replaces the adapter (used by tests).

import type { PlatformAdapter } from "./types";

export type { PlatformAdapter, NativePushRegistration } from "./types";

let current: PlatformAdapter | null = null;

export function setPlatform(adapter: PlatformAdapter): void {
  current = adapter;
}

export function platform(): PlatformAdapter {
  if (!current) {
    throw new Error(
      "platform() called before setPlatform() — main.ts must wire an adapter at boot.",
    );
  }
  return current;
}

// Returns the adapter or null. Use this when fire-and-forget code
// runs before main.ts can register one (e.g. very early auth.ts
// imports during a test setup that didn't bootstrap the platform).
export function platformOrNull(): PlatformAdapter | null {
  return current;
}

// Test-only — drops the adapter so the next test re-installs a clean fake.
export function __resetPlatform(): void {
  current = null;
}
